import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import DeviceDataApiForm from './DeviceDataApiForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission, isValidJson } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as actions from "./store/deviceDataApiActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      paddingRight: 0,
    }
  },
  submit: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
    alignItems: "center"
  },
  cancel: {
    width: "250px",
    margin: "10px"
  }
});

const DeviceDataApiEdit = props => {
  const { deviceDataApi, classes, onFetchDeviceDataApiInit, activeCustomer, translations, permissions, onFetchDeviceDataApi, onEditDeviceDataApi } = props;
  const [data, setData] = useState(true);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      await onFetchDeviceDataApi({ ActiveCustomerID: activeCustomer, DeviceDataApiID: parseURL(window.location.href).deviceDataApiID });
      setData(false);
    }
    fetchData();
    return () => {
      onFetchDeviceDataApiInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (deviceDataApi && isValidJson(deviceDataApi?.Settings)) {
      setSettings(JSON.parse(deviceDataApi.Settings))
    }
  }, [deviceDataApi]);

  const handleSubmit = async data => {
    let objectToSend = { ...data };
    objectToSend['DeviceDataApiID'] = deviceDataApi.DeviceDataApiID;
    let result = await onEditDeviceDataApi({ ...objectToSend, ActiveCustomerID: activeCustomer });
    if (result) {
      History.goBack()
    }
  }

  let initialValues = {
    Name: deviceDataApi?.Name || "",
    Type: deviceDataApi?.Type || "",
    Active: deviceDataApi?.Active || false,
    AppleFullData: settings?.AppleFullData || false,
    AppleSimlockOnly: settings?.AppleSimlockOnly || false,
    GsmaBlacklist: settings?.GsmaBlacklist || false,
    RecallBehavior: settings?.RecallBehavior || "on_error",
    SamsungWorldwide: settings?.SamsungWorldwide || false,
    MdmWork: settings?.MdmWork || false,
    AppleICloudLock: settings?.AppleICloudLock || false,
    Autopilot: settings?.Autopilot || false,
  };

  let formSettings = {
    Validation: {
      Name: Yup.string().required("Required"),
      Type: Yup.string().required("Required"),
      Active: Yup.boolean().required("Required"),
      RecallBehavior: Yup.string().required("Required"),
    },
    FormTitle: translations['edit_device_data_api'] || 'Edit device data API',
    ButtonSubmit: hasPermission(permissions, "device_data_api_save") ? {
      Title: translations["save"] || "SAVE",
      Color: 'primary'
    } : null
  };

  return (
    <Paper className={classes.root} >
      {BackButton(translations)}
      <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
        PaperProps={{
          classes: {
            root: classes.submit
          }
        }} >

        <AppLogoLoading />
      </Dialog>
      {!data ?
        <DeviceDataApiForm
          formSettings={formSettings}
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          translations={translations}
        />
        : <CircularProgress
          variant='determinate'
          color='primary'
          size={28}
        />}
    </Paper>)
}

const mapStateToProps = state => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    permissions: state?.core?.login?.permissions || [],
    deviceDataApi: state?.setting?.deviceDataApi?.loaded || {},
    translations: state?.translate?.translations?.activeTranslations || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchDeviceDataApiInit: deviceDataApi => dispatch(actions.loadDeviceDataApiInit(deviceDataApi)),
    onFetchDeviceDataApi: deviceDataApi => dispatch(actions.loadDeviceDataApi(deviceDataApi)),
    onEditDeviceDataApi: deviceDataApi => dispatch(actions.editDeviceDataApi(deviceDataApi)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DeviceDataApiEdit));
